// extracted by mini-css-extract-plugin
export default {"starterScreen":"em","starterImage":"fm","already":"gm","starterImageMobile":"hm","controlX":"im","starterTextContain":"jm","starterHeader":"km","starterBtn":"lm","starterSecondaryBtn":"mm","starterBanner":"nm","mobileBtnContainer":"om"};
    if(module.hot) {
      // 1715276855165
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  